@use '@dixa/lib-shared-tokens/scss' as *;

.selectionList {
  max-height: 400px;
  overflow: auto;
}

.selectionListItemContent {
  display: flex;
  align-items: center;
  gap: var(--dixa-size-spacer-300);
}

.selectionListItemText {
  flex-grow: 1;
}

.pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: var(--dixa-size-spacer-300);
  @include border-top-100();
}
